import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { Box, Button, IconButton, Paper, Switch, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import toast from 'react-hot-toast';
import service from '../../api/services';
import SoftButton from 'components/SoftButton';
import { useAuth } from 'AuthContext';
import { render } from '@testing-library/react';
// Columns configuration


const Review = () => {
    const navigate = useNavigate()
    const [ isApiLoading , setIsApiLoading ] = React.useState(true)
    const [data, setData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [page, setPage] = React.useState(1);
    const [show, setShow] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
      const [sortValue, setSortValue] = React.useState({sortKey:'name',sortDirection:'asc'});
    const columns = [
        { id: 'name', isSorting: true,sortDirection:'asc',label: 'Name' },
        { id: 'type', isSorting: true,sortDirection:'asc',label: 'Type',

            render:(row)=>(
                  <>
                    {row?.type ? row?.type?.map((item)=>item)?.join(' , ') : '-'}
                </>
            )
         },
        {
            id: 'category',isSorting: true,sortDirection:'asc', label: 'Category', render: (row) => (
                <>
                    {row?.category ? row?.category?.map((item)=>item?.name)?.join(' , ') : '-'}
                </>

            )
        },
        {
            id: 'actions',
            label: 'Actions',
            render: (row) => (
                <ActionMenu
                    items={[
                        { label: 'Edit', onClick: () => { navigate(`/admin/edit-review/${row._id}`) } },
                        { label: 'Remove', onClick: () => { deleteReview(row._id) } },

                    ]}
                />
            )
        }
    ];

    const deleteReview = async (id) => {
        try {
            const response = await service.reviewList.delete(id);

            if ([200, 201].includes(response.status)) {
                toast.success(response.message || 'deleted successfully.');
                getUserDetail();
            } else {
                toast.error(response.message || 'Failed to delete .');
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while deleting .';
            toast.error(errorMessage);
            console.error('Deletion error:', error);
        }
    };
    const getUserDetail = async () => {
        setIsApiLoading(true)
        try {
            const response = await service.reviewList.listDetail(localStorage.getItem('id'), { searchData: search, page,sortKey:sortValue.sortKey ,sortDirection:sortValue.sortDirection, limit: rowsPerPage });
            if (response?.data?.data) {
                setData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
          setIsApiLoading(false)
    };

    React.useEffect(() => {
        getUserDetail();
    }, [search, page, rowsPerPage,sortValue])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
                <Box display="flex" alignItems="center" justifyContent={'end'}>
                    <SoftButton variant="gradient" color="info" onClick={() => navigate('/admin/add-review')}>Add</SoftButton>
                </Box>
                <CustomTable
                    title="Review List" columns={columns}
                    rows={data?.data || []}
                    search={search}
                    setSearch={setSearch}
                    page={page}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    isApiLoading={isApiLoading}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={data?.pagination?.totalItems}
                    onRequestSort={(id, direction) => {
                        setSortValue({ sortKey: id, sortDirection: direction })

                    }}
                />
            </Paper>
        </DashboardLayout>
    );
}

export default Review
